export const ROOT_BACKEND_API = "https://prod.helloatlas.in/manipal";
// export const ROOT_BACKEND_API = "http://localhost:5000/manipal";